import { atomWithStorage } from 'jotai/utils';
import { ECookiesStorageKeys } from 'common/enums/cookies-storage.enums.ts';
import { cookieStorageUtil } from 'common/utils/cookies.utils.ts';
import { EThemes, EThemesSelector } from 'theme/enums/theme.enums.ts';

const themeSelectorStorage = cookieStorageUtil<EThemesSelector>();
export const themeSelectorAtom = atomWithStorage<EThemesSelector>(
  ECookiesStorageKeys.ThemeSelector,
  EThemesSelector.Light,
  themeSelectorStorage
);

const themesStorage = cookieStorageUtil<EThemes>();
export const themeNameAtom = atomWithStorage<EThemes>(ECookiesStorageKeys.Theme, EThemes.Light, themesStorage);
